import { ReactNode } from 'react';
import { Spinner } from '../Spinner/Spinner';

interface ILoadingContainerProps {
  isLoading?: boolean;
  spinnerSize?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export const LoadingContainer = ({
  isLoading = true,
  spinnerSize,
  children
}: ILoadingContainerProps) => {
  if (isLoading) return <Spinner size={spinnerSize} className="d-block" />;
  return <>{children}</>;
};

export default Spinner;
